import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import api from "./lib/api";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Analytics from "./pages/Analytics";
import Goals from "./pages/Goals";
import DailyWork from "./pages/DailyWork";
import Requirements from "./pages/Requirements";
import Stock from "./pages/Stock";
import Masters from "./pages/Masters";
import Reports from "./pages/Reports";
import Procurement from "./pages/Procurement";
import Quotations from "./pages/Quotations";
import Vendors from "./pages/Vendors";
import Inventory from "./pages/Inventory";
import Budget from "./pages/Budget";
import Team from "./pages/Team";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const run = async () => {
      const hash = location.hash || window.location.hash;
      const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
      if (!sid) { navigate("/"); return; }
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    };
    run();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy">
      <div className="text-white font-heading text-lg animate-pulse">Signing you in…</div>
    </div>
  );
};

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-background text-brand-slate">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/daily" element={<DailyWork />} />
        <Route path="/requirements" element={<Requirements />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/masters" element={<Masters />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/procurement" element={<Procurement />} />
        <Route path="/quotations" element={<Quotations />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/budget" element={<Budget />} />
        <Route path="/team" element={<Team />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
